import React, { useState, useMemo } from "react";
import { CheckProps } from "./type";
import "../../styles/check.scss";
import _ from "lodash";

const Check = ({ label, onChange, checked }: CheckProps) => {
  const [isChecked, setChecked] = useState(checked);
  const onCheckChanged = () => {
    const newCheck = !isChecked;
    onChange?.(newCheck);
    setChecked(newCheck);
  };
  const uniqueId = useMemo(() => _.uniqueId('js-checkbox-'), []);

  return (
    <div className="check-container">
      <input type="checkbox" checked={isChecked} onChange={onCheckChanged} id={uniqueId} />
      <label className="check-label" htmlFor={uniqueId}>{label}</label>
    </div>
  );
};

export default Check;
